import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';
import SideDrawer from '../SideDrawer';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { Menu } from '@material-ui/icons';
import { wrapEventHandler } from '../../utils/handlers';

class NavigationDrawer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  toggleIsOpen = e => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen }, this.toggleWindowLockAndTrack);
  };

  toggleWindowLockAndTrack() {
    this.trackSliderOpen();
    this.toggleWindowLock();
  }

  trackSliderOpen() {
    _gaq.push(['_trackEvent', 'Mobile Header', 'Toggle', window.location.pathname]);
  }

  toggleWindowLock() {
    this.state.isOpen
      ? document.querySelector('html').classList.add('mobile-screen-lock')
      : document.querySelector('html').classList.remove('mobile-screen-lock');
  }

  updateLinkRef(linkPath) {
    return linkPath.replace('?ref=header', '?ref=mobile-header');
  }

  updateDropdownLinkRef(link) {
    if (!link.dropdown) {
      return;
    }

    return link.dropdown.map(dropdownLink => {
      return { ...dropdownLink, linkPath: this.updateLinkRef(dropdownLink.linkPath) };
    });
  }

  parseLinkRef(links) {
    if (!links) {
      return;
    }

    return links.map(link => {
      return { ...link, linkPath: this.updateLinkRef(link.linkPath), dropdown: this.updateDropdownLinkRef(link) };
    });
  }

  getMobileLinks() {
    // here we need to parse the links to have ?ref=mobile-header for tracking
    // parsing this on the client so the server doesn't need to generate a new routes
    const {
      links: { explore, plan, history, help, downloadApp },
      user
    } = this.props;
    let dropdownLinks = [explore, plan, history];
    let links = [help, downloadApp];

    if (user.dropdown.length > 0) {
      const myAccount = { label: StringConstantsMixin.strings.MY_ACCOUNT, linkPath: '#', dropdown: user.dropdown };
      dropdownLinks.push(myAccount);
    }

    dropdownLinks = this.parseLinkRef(dropdownLinks);
    links = this.parseLinkRef(links);

    return { dropdownLinks, links };
  }

  sideDrawerProps() {
    const { proButton, user } = this.props;
    let sideDrawerProps = this.getMobileLinks();
    return {
      ...sideDrawerProps,
      adminUser: this.props.context.adminUser,
      isOpen: this.state.isOpen,
      toggleIsOpen: wrapEventHandler(this.toggleIsOpen),
      proButton,
      user
    };
  }

  render() {
    const sideDrawerProps = this.sideDrawerProps();

    return (
      <>
        <a href="#" onClick={wrapEventHandler(this.toggleIsOpen)} className={styles.navigationMenuLink}>
          <Menu className={styles.navigationMenu} />
        </a>
        <SideDrawer {...sideDrawerProps} />
      </>
    );
  }
}

NavigationDrawer.propTypes = {
  context: PropTypes.shape({
    adminUser: PropTypes.bool,
    proUser: PropTypes.bool,
    mobileBrowser: PropTypes.bool,
    tabletBrowser: PropTypes.bool,
    displayMetric: PropTypes.bool
  }),
  user: PropTypes.shape({
    name: PropTypes.string,
    linkPath: PropTypes.string,
    imagePath: PropTypes.string,
    reputation: PropTypes.number,
    display: PropTypes.bool,
    login: PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string
    }),
    signup: PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string
    }),
    proButton: PropTypes.shape({
      label: PropTypes.string,
      linkPath: PropTypes.string,
      display: PropTypes.bool
    }),
    links: PropTypes.shape({
      explore: PropTypes.shape({
        label: PropTypes.string,
        linkPath: PropTypes.string
      }),
      plan: PropTypes.shape({
        label: PropTypes.string,
        linkPath: PropTypes.string,
        dropdown: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            linkPath: PropTypes.string
          })
        )
      }),
      history: PropTypes.shape({
        label: PropTypes.string,
        linkPath: PropTypes.string,
        dropdown: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            linkPath: PropTypes.string
          })
        )
      }),
      help: PropTypes.shape({
        label: PropTypes.string,
        linkPath: PropTypes.string,
        dropdown: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            linkPath: PropTypes.string
          })
        )
      })
    })
  })
};

export default NavigationDrawer;
